const get = state => state.renderConfig;

export const getRenderConfig = state => get(state);